import {
    GET_CREDIT_LIMIT_MODEL_DATA_SUCCESS,
    UPDATE_CREDIT_LIMIT_MODEL_RESPONSE
} from '../Edit/action';
const initialState = {
    creditLimitModelDataSuccess: [],
    updateCreditLimitModelResponse:[]
}

const creditLimitModelDataReducer = (state=initialState, action) => {
    switch(action.type) {
        case GET_CREDIT_LIMIT_MODEL_DATA_SUCCESS:
            return  state = {
                ...state,
                creditLimitModelDataSuccess: action.data
            }
        case UPDATE_CREDIT_LIMIT_MODEL_RESPONSE:
            return  state = {
                ...state,
                updateCreditLimitModelResponse: action.data
            }    
        default: return state
    }
}
export default creditLimitModelDataReducer;
